export default __webpack_public_path__ + "8886a580b1f9fa04ecda0d5243a6eb72.png";